import React from 'react'
import './PDFViewer.scss'

const LuxPDFViewer = (props: {
    src: string
    width?: string
    height?: string
}) => {
    const { src, width, height } = props

    return <iframe src={src} width={width || '100%'} height={height || 800} />
}

export default LuxPDFViewer
